import { Text } from "@ferrivia/ui";
import s from "./EmptyPane.module.css";

export interface EmptyPaneProps {
  title: string;
  body: string;
}

export function EmptyPane({ title, body }: EmptyPaneProps) {
  return (
    <div className={s.root}>
      <Text as="h1" size="xl" weight="bold">
        {title}
      </Text>
      <Text as="p" className={s.body}>
        {body}
      </Text>
    </div>
  );
}
